import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';

import { generateUid } from '~/core/helpers/uid/uid.helper';

export class APIThrottleInterceptor implements HttpInterceptor {
  private readonly queue = [];
  private readonly reqObs: { [key: string]: Subscriber<unknown> } = {};
  private counter = 0;

  constructor(
    private readonly validUrls: string[],
    private readonly limit: number
  ) {}

  private isValidUrl(url: string): boolean {
    return this.validUrls.some((validUrl) => url.startsWith(validUrl));
  }

  private updateData(): void {
    if (this.counter > 0) {
      this.counter--;
    }

    if (this.queue?.length > 0) {
      const id = this.queue.shift();
      const observer = this.reqObs[id];

      observer?.next('done!');
      observer?.complete();

      delete this.reqObs[id];
    }
  }

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.isValidUrl(req.url)) {
      if (this.counter < this.limit) {
        this.counter++;

        return next.handle(req).pipe(
          tap((event) => {
            if (event instanceof HttpResponse) {
              this.updateData();
            }

            return event;
          })
        );
      }
      const id = generateUid();
      this.queue.push(id);
      this.reqObs[id] = null;

      const obs = new Observable((ob) => {
        this.reqObs[id] = ob;
      });

      return obs.pipe(
        concatMap((_) => {
          return next.handle(req).pipe(
            tap((event) => {
              if (event instanceof HttpResponse) {
                this.updateData();
              }

              return event;
            })
          );
        })
      );
    }

    return next.handle(req);
  }
}
